import { ALL_FISHING_WATERS_TOGGLEABLE_GROUPS } from '../constants/mapLayers/fishingWaters';
import { ALL_POI_TOGGLEABLE_GROUPS } from '../constants/mapLayers/pointsOfInterest';
import { ALL_WAYPOINTS_TOGGLEABLE_GROUPS } from '../constants/mapLayers/waypoints';
import { FishbrainLayers, ToggleableLayer } from '../types/types';

import { MAPBOX_LAYERS } from './layers';
import { SOURCE } from './sources';

export const TOGGLEABLE_LAYERS: FishbrainLayers<ToggleableLayer> = {
  fishingWaters: {
    mapboxLayers: MAPBOX_LAYERS.fishingWaters.mapboxLayers,
    title: 'Fishing waters',
    shouldShowBasedOnUrl: drawerView => drawerView === 'fishing-water',
    localStorageKey: 'map.toggleableLayer.fishingWaters',
    premiumOnly: SOURCE.fishingWaters.premiumOnly,
    visibleByDefault: true,
    defaultToggleableGroups: ALL_FISHING_WATERS_TOGGLEABLE_GROUPS,
  },
  spotPrediction: {
    mapboxLayers: MAPBOX_LAYERS.spotPrediction.mapboxLayers,
    title: 'Spot prediction',
    shouldShowBasedOnUrl: () => false,
    localStorageKey: 'map.toggleableLayer.spotPrediction',
    premiumOnly: SOURCE.spotPrediction.premiumOnly,
    visibleByDefault: true,
    defaultToggleableGroups: [],
  },
  catchPositions: {
    mapboxLayers: MAPBOX_LAYERS.catchPositions.mapboxLayers,
    title: 'Catch positions',
    shouldShowBasedOnUrl: drawerView => drawerView === 'catch',
    localStorageKey: 'map.toggleableLayer.catchPositions',
    premiumOnly: SOURCE.catchPositions.premiumOnly,
    visibleByDefault: true,
    defaultToggleableGroups: [],
  },
  pointsOfInterest: {
    mapboxLayers: MAPBOX_LAYERS.pointsOfInterest.mapboxLayers,
    title: 'Points of interest',
    shouldShowBasedOnUrl: drawerView => drawerView === 'poi',
    localStorageKey: 'map.toggleableLayer.pointsOfInterest',
    premiumOnly: SOURCE.pointsOfInterest.premiumOnly,
    visibleByDefault: true,
    defaultToggleableGroups: ALL_POI_TOGGLEABLE_GROUPS,
  },
  artificialReefs: {
    mapboxLayers: MAPBOX_LAYERS.artificialReefs.mapboxLayers,
    title: 'Artificial reefs',
    shouldShowBasedOnUrl: drawerView => drawerView === 'artificial-reef',
    localStorageKey: 'map.toggleableLayer.artificialReefs',
    premiumOnly: SOURCE.artificialReefs.premiumOnly,
    visibleByDefault: false,
    defaultToggleableGroups: [],
  },
  waypoints: {
    mapboxLayers: MAPBOX_LAYERS.waypoints.mapboxLayers,
    title: 'Your waypoints',
    shouldShowBasedOnUrl: drawerView => drawerView === 'waypoint',
    localStorageKey: 'map.toggleableLayer.waypoints',
    premiumOnly: SOURCE.waypoints.premiumOnly,
    visibleByDefault: true,
    defaultToggleableGroups: ALL_WAYPOINTS_TOGGLEABLE_GROUPS,
  },
};
